import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { NavbarStatisticsState } from './navbar-statistics-state';


export class NavbarStatisticsStateService {
	public readonly  _state = new BehaviorSubject<NavbarStatisticsState>({
		requireActionInterviewsCount: 0,
		loading: true
	});

	public readonly $state = this._state.asObservable().map((state) => Object.assign({}, state));

	public get state(): NavbarStatisticsState {
		return {...this._state.getValue()};
	}

	public set state(state: NavbarStatisticsState) {
		this._state.next(state);
	}

	public setRequireActionInterviewsCount(requireActionInterviewsCount: number) {
		this.state = {
			...this.state,
			requireActionInterviewsCount,
			loading: false
		};
	}
}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/shared/navbar/client/store/navbar-statistics-state.service.ts